export default __webpack_public_path__ + "static/media/fog.5ba173e3.svg";